class Slideshow {
  constructor(section) {
    this.section = section;
    this.box = section.querySelector('.slidshow-wrap');
    this.id = section.id;
    this.swiper = null;
    this.init();
  }

  init() {
    if (!this.box) return;
    this.initializeSwiper();
  }

  initializeSwiper() {
    if (this.section.classList.contains('slideshow_started')) return;
    this.section.classList.add('slideshow_started');

    const { autoplay, stopAutoplay, delay, speed } = this.box.dataset;
    const autoplayEnabled = autoplay === 'true';
    const stopAutoplayEnabled = stopAutoplay === 'true';

    const slides = this.section.querySelectorAll('.swiper-slide');
    const hasEnoughSlides = slides.length > 1;

    const autoplayParam = autoplayEnabled && hasEnoughSlides
      ? {
        autoplay: {
          delay: parseFloat(delay) * 1000,
          pauseOnMouseEnter: stopAutoplayEnabled,
          disableOnInteraction: false,
          waitForTransition: true,
        },
      }
      : {};

    const swiperParams = {
      speed: parseFloat(speed) * 1000,
      loop: hasEnoughSlides,
      centeredSlides: false,
      keyboard: true,
      watchSlidesProgress: true,
      a11y: {
        enabled: true,
        prevSlideMessage: 'Previous slide',
        nextSlideMessage: 'Next slide',
      },
      pagination: {
        el: `#${this.id} .slideshow-pagination`,
        clickable: true,
        dynamicBullets: false,
        enabled: hasEnoughSlides
      },
      navigation: {
        prevEl: `#${this.id} .slideshow-arrow-prev`,
        nextEl: `#${this.id} .slideshow-arrow-next`,
        enabled: hasEnoughSlides
      },
      passiveListeners: true,
      ...autoplayParam,
    };

    if (!hasEnoughSlides) {
      const prevButton = this.section.querySelector('.slideshow-arrow-prev');
      const nextButton = this.section.querySelector('.slideshow-arrow-next');
      const pagination = this.section.querySelector('.slideshow-pagination');

      if (prevButton) prevButton.style.display = 'none';
      if (nextButton) nextButton.style.display = 'none';
      if (pagination) pagination.style.display = 'none';
    }

    if (!document.querySelector(`#${this.id} .slideshow`)) return;

    this.swiper = new Swiper(`#${this.id} .slideshow`, swiperParams);

    this.swiper.on('init', () => {
      this.swiper.pagination.update();
      this.swiper.update();
    });
  }

  destroy() {
    if (this.swiper) {
      this.swiper.destroy(true, true);
      this.swiper = null;
    }
    this.section.classList.remove('slideshow_started');
  }

  updatePagination() {
    if (this.swiper) {
      this.swiper.update();
      this.swiper.pagination.update();
    }
  }
}

const slideshowInstances = new Map();

function initSlideshows(container = document) {
  const sections = container.querySelectorAll('.slideshow-section');
  sections.forEach(section => {
    const id = section.id || 'default';
    if (slideshowInstances.has(id)) {
      slideshowInstances.get(id).destroy();
    }
    const instance = new Slideshow(section);
    slideshowInstances.set(id, instance);
  });
}

document.addEventListener('DOMContentLoaded', () => initSlideshows());

document.addEventListener('shopify:section:load', (event) => {
  if (event.target.querySelector('.slideshow-section')) {
    initSlideshows(event.target);
  }
});

document.addEventListener('shopify:section:unload', (event) => {
  const section = event.target.querySelector('.slideshow-section');
  if (section && section.id && slideshowInstances.has(section.id)) {
    slideshowInstances.get(section.id).destroy();
    slideshowInstances.delete(section.id);
  }
});

if (window.Shopify && window.Shopify.designMode) {
  document.addEventListener('shopify:section:select', (event) => {
    const section = event.target.querySelector('.slideshow-section');
    if (section && section.id) {
      const instance = slideshowInstances.get(section.id);
      if (instance && instance.swiper && instance.swiper.autoplay) {
        instance.swiper.autoplay.stop();
      }
    }
  });

  document.addEventListener('shopify:section:deselect', (event) => {
    const section = event.target.querySelector('.slideshow-section');
    if (section && section.id) {
      const instance = slideshowInstances.get(section.id);
      if (instance && instance.swiper && instance.swiper.autoplay) {
        instance.swiper.autoplay.start();
      }
    }
  });

  document.addEventListener('shopify:block:select', function (event) {
    const slide = event.target.closest('.swiper-slide');
    if (!slide) return;

    const slideshowSection = event.target.closest('.slideshow-section');
    if (slideshowSection && slideshowSection.id) {
      const instance = slideshowInstances.get(slideshowSection.id);
      if (instance && instance.swiper) {
        const index = Array.from(slideshowSection.querySelectorAll('.swiper-slide:not(.swiper-slide-duplicate)')).indexOf(slide);
        if (index > -1) {
          instance.swiper.slideToLoop(index);
          instance.swiper.autoplay.stop();
        }
      }
    }
  });

  document.addEventListener('shopify:block:deselect', function (event) {
    const slideshowSection = event.target.closest('.slideshow-section');
    if (slideshowSection && slideshowSection.id) {
      const instance = slideshowInstances.get(slideshowSection.id);
      if (instance && instance.swiper && instance.swiper.autoplay) {
        instance.swiper.autoplay.start();
      }
    }
  });
}